export default __webpack_public_path__ + "static/media/trash.7c65d4ae.svg";